import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Form, Input } from 'semantic-ui-react';

import { fetchWeather } from '../actions/index';

class SearchBar extends Component {
	state = { query: '' };

	handleInputChange = event => {
		this.setState({ query: event.target.value });
	};

	handleFormSubmit = () => {
		this.props.fetchWeather(this.state.query);
		this.setState({ query: '' });
	};

	render() {
		return (
			<Form onSubmit={this.handleFormSubmit}>
				<Input
					fluid
					action
					type="text"
					placeholder="5-day forecast for any location"
					size="huge"
					value={this.state.query}
					onChange={this.handleInputChange}
					autoFocus="true"
				>
					<input />
					<Button type="submit">Search</Button>
				</Input>
			</Form>
		);
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators({ fetchWeather }, dispatch);

export default connect(null, mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/containers/SearchBar.js